import lhServerClient from ".";
import { CommonCustomizationType } from "./enum";

export interface CommonCustomization {
    id: number;

    shopId: number;

    type: CommonCustomizationType;
}

export interface BottomPanel {
    id: number;

    name: string;

    type: CommonCustomizationType;

    index?: number;
}

export interface PanelAspect {
    id: number;
    bottomPanelId: number;
    name: string;
    /**通过来火oss上传图片的话，返回的cloudFileId */
    bottomImageFileId?: number;
    bottomImageUrl: string;
    /**通过来火oss上传图片的话，返回的cloudFileId */
    topImageUrl?: string;
    topImageFileId?: number;
    /**整数 */
    customizeWidth: number;
    /**整数 */
    customizeHeight: number;
    /**整数 */
    customizeLeft: number;
    /**整数 */
    customizeTop: number;
    /**
     * 整数
     * 精度为1000,实际使用应除以1000
     */
    scale: number;

    index?: number;
}

/**
 * 获取底板列表
 */
export function getBottomPanelList(type: CommonCustomizationType) {
    return lhServerClient.get<BottomPanel[]>("/common_customization/bottom_panel/list", {
        type,
    });
}

/**
 * 获取底板定制面列表
 */
export function getBottomPanelAspectList(panelId: number) {
    return lhServerClient.get<PanelAspect[]>("/common_customization/bottom_panel/aspect/list", { panelId });
}
